const md = `# Persona-Targeted Narration

Generic demo narration is forgettable.  *Persona-targeted* narration
tells the same workflow's story through the lens of one specific
stakeholder.

## The four personas

| Persona | Tone | Focuses on |
|---------|------|-------------|
| **Default** | Neutral, instructional | Step-by-step explanation. |
| **CFO** | Executive, numerical | Cost control, audit trail, dollars-per-day saved. |
| **Head of Procurement** | Tactical, process-led | Cycle time, supplier compliance, OOP spend. |
| **IT Director** | Architectural | Integrations, cXML, SSO, security posture. |

## Picking a persona

Open any run-detail page.  Above the narration panel you'll see a
**Persona** dropdown.  Pick one and click **Regenerate** — a fresh
GPT-5.2 call writes a new script, and the voiceover/MP4 are produced
behind it.

You can also pick a persona at *run time* — the Run modal carries the
same dropdown.  Choose then before you hit Run, and the auto-pipeline
will use it.

## What changes under the hood

The persona is passed to GPT-5.2 as part of the system prompt
("You are writing for a CFO who cares about…").  It rewrites the same
step log + screenshots from the chosen angle.  Same audio voice, same
MP4 length — different *story*.

## A worked example

The Free-form workflow's *Default* narration says:

> *"In the Eyvo dashboard, we click 'New Requisition'…"*

The same run's *CFO* narration says:

> *"This single click triggers our standardised approval flow,
> ensuring every dollar of OOP spend hits the audit log before it
> leaves the building."*

Same screenshots.  Same workflow.  Different demo.
`;

export default md;
